import { createSlice } from "@reduxjs/toolkit";
import { GetIntegrationAction } from "redux/action/IntegrationAction";

// Define the initial state for the slice
const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

// Create the IntegrationSlice using createSlice
const IntegrationSlice = createSlice({
  name: 'integrations',
  initialState,
  reducers: {
    // Handler for setting integration data
    getintegrationHandler: (state:any, action:any) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Handle the pending state of GetIntegrationAction
    builder.addCase(GetIntegrationAction.pending, (state:any) => {
      state.isLoading = true;
    });

    // Handle the fulfilled state of GetIntegrationAction
    builder.addCase(GetIntegrationAction.fulfilled, (state:any, action:any) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    // Handle the rejected state of GetIntegrationAction
    builder.addCase(GetIntegrationAction.rejected, (state:any) => {
      state.isLoading = false;
    });
  }
});

export default IntegrationSlice;
